export const hexToRgb = (hex: string): { r: number; g: number; b: number; a: number } => {
    // Handle shorthand hex
    const formattedHex = hex.startsWith('#') ? hex.substring(1) : hex;

    // Parse the hex values
    let r = 0, g = 0, b = 0, a = 100;

    if (formattedHex.length === 3) {
        r = parseInt(formattedHex[0] + formattedHex[0], 16);
        g = parseInt(formattedHex[1] + formattedHex[1], 16);
        b = parseInt(formattedHex[2] + formattedHex[2], 16);
    } else if (formattedHex.length >= 6) {
        r = parseInt(formattedHex.substring(0, 2), 16);
        g = parseInt(formattedHex.substring(2, 4), 16);
        b = parseInt(formattedHex.substring(4, 6), 16);

        // Handle alpha if present
        if (formattedHex.length === 8) {
            a = Math.round(parseInt(formattedHex.substring(6, 8), 16) / 2.55);
        }
    }

    return { r, g, b, a };
};

// Helper to convert RGB to hex
export const rgbToHex = (r: number, g: number, b: number, a: number = 100): string => {
    const toHex = (value: number) => {
        const hex = Math.max(0, Math.min(255, Math.round(value))).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };

    // Handle alpha
    const alphaHex = a < 100 ? toHex(Math.round(a * 2.55)) : '';

    return `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`;
};

// New helper function to convert RGB to HSV
export const rgbToHsv = (r: number, g: number, b: number): { h: number; s: number; v: number } => {
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    let h = 0;
    const s = max === 0 ? 0 : delta / max;
    const v = max;

    if (delta === 0) {
        h = 0;
    } else if (max === r) {
        h = ((g - b) / delta) % 6;
    } else if (max === g) {
        h = (b - r) / delta + 2;
    } else {
        h = (r - g) / delta + 4;
    }

    h = Math.round(h * 60);
    if (h < 0) h += 360;

    return { h, s, v };
};


export const hsvToRgb = (h: number, s: number, v: number): { r: number; g: number; b: number } => {
    h = h % 360;
    s = Math.max(0, Math.min(1, s));
    v = Math.max(0, Math.min(1, v));
  
    const c = v * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = v - c;
  
    let r = 0, g = 0, b = 0;
  
    if (h >= 0 && h < 60) {
      r = c; g = x; b = 0;
    } else if (h >= 60 && h < 120) {
      r = x; g = c; b = 0;
    } else if (h >= 120 && h < 180) {
      r = 0; g = c; b = x;
    } else if (h >= 180 && h < 240) {
      r = 0; g = x; b = c;
    } else if (h >= 240 && h < 300) {
      r = x; g = 0; b = c;
    } else {
      r = c; g = 0; b = x;
    }
  
    return {
      r: Math.round((r + m) * 255),
      g: Math.round((g + m) * 255),
      b: Math.round((b + m) * 255)
    };
  };